import { Directive, HostListener, Input, Renderer2 } from '@angular/core';

/**
 * Manages the behaviour of the tooltip so that it does not appear on certain occasions:
 * - If sidebar is open
 * - If there is a submenu and it is open
 * - If it is the new button on the topbar
 */

@Directive({
    selector: '[cwBarsTooltip]',
    standalone: false,
})
export class BarsTooltipDirective {
    @Input() isTopbar: boolean | undefined = false;

    constructor(private rendered: Renderer2) {}

    @HostListener('mouseenter', ['$event.target'])
    handlerTooltipBehavior(target: HTMLElement): void {
        const isNewButton = target.classList.contains('twc-button-primary');
        const sidebar = target.closest('twc-sidebar');
        const isSidebarOpen = sidebar?.classList.contains('twc-expanded') || false;

        if (isSidebarOpen || (this.isTopbar && isNewButton) || this.isSubmenuOpen(target)) {
            this.hideTooltip();
        }
    }

    @HostListener('click', ['$event.target'])
    hideTooltip(): void {
        setTimeout(() => {
            const tooltip = document.body.getElementsByClassName('twc-tooltip')[0];

            if (tooltip) {
                this.rendered.setStyle(tooltip, 'visibility', 'hidden');
            }
        }, 10);
    }

    isSubmenuOpen(target: HTMLElement): boolean {
        const submenu: HTMLElement | null = target.querySelector('twc-menu');

        return submenu?.style.visibility === 'visible';
    }
}
